import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Instagram, Linkedin } from "lucide-react";
import { Logo } from "./Logo";
import { useI18n } from "../lib/i18n";

export function Footer() {
  const { t } = useI18n();
  const legal = [
    { to: "/legal/mentions", key: "linkLegalNotice" },
    { to: "/legal/cgv", key: "linkTerms" },
    { to: "/legal/cgu", key: "linkTermsUse" },
    { to: "/legal/confidentialite", key: "linkPrivacy" },
    { to: "/legal/cookies", key: "linkCookies" },
    { to: "/legal/accessibilite", key: "linkAccessibility" },
  ];
  const product = [
    { to: "/", key: "linkHowItWorks" },
    { to: "/", key: "linkForBusiness" },
    { to: "/", key: "linkForCreators" },
  ];

  return (
    <footer className="relative border-t border-cardline bg-ink2/40" data-testid="site-footer">
      <div className="mx-auto max-w-5xl px-4 py-12">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Logo size={28} />
            <p className="mt-3 max-w-xs text-sm text-slate-400">{t("footerTagline")}</p>
            <div className="mt-4 flex gap-2">
              {[Instagram, Linkedin, Mail].map((Icon, i) => (
                <a key={i} href="#" className="grid h-9 w-9 place-items-center rounded-full border border-cardline bg-ink2/60 text-slate-400 transition-colors hover:border-gold hover:text-gold" aria-label="social">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white">{t("footerProduct")}</h4>
            <ul className="mt-3 space-y-2 text-sm text-slate-400">
              {product.map((l, i) => (
                <li key={i}><Link to={l.to} className="transition-colors hover:text-gold" data-testid={`footer-${l.key}`}>{t(l.key)}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white">{t("footerCompany")}</h4>
            <ul className="mt-3 space-y-2 text-sm text-slate-400">
              <li><Link to="/legal/contact" className="transition-colors hover:text-gold" data-testid="footer-contact">{t("linkContact")}</Link></li>
              <li className="flex items-center gap-1.5"><MapPin size={13} /> Lyon, France</li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white">{t("footerLegal")}</h4>
            <ul className="mt-3 space-y-2 text-sm text-slate-400">
              {legal.map((l, i) => (
                <li key={i}><Link to={l.to} className="transition-colors hover:text-gold" data-testid={`footer-${l.key}`}>{t(l.key)}</Link></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-cardline pt-6 text-xs text-slate-500 sm:flex-row">
          <p>© 2026 Local Creators. {t("allRights")}</p>
          <div className="flex gap-4">
            <Link to="/legal/mentions" className="hover:text-slate-300">{t("linkLegalNotice")}</Link>
            <Link to="/legal/confidentialite" className="hover:text-slate-300">{t("linkPrivacy")}</Link>
            <Link to="/legal/cookies" className="hover:text-slate-300">{t("linkCookies")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
